/** Human-readable list of missing fields for form validation notifications. */
export function missingFieldMessage(keys: string[], labels: Record<string, string>): string {
  const missing = keys.map((key) => labels[key]).filter(Boolean);
  return missing.length > 0
    ? `Please complete: ${missing.join(', ')}`
    : 'Please complete all required fields highlighted in red.';
}

export function digitsOnly(value: string): string {
  return value.replace(/\D/g, '');
}
